// src/components/TrialBanner.jsx
import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosInstance';

function diffInDays(from, to) {
  const t1 = new Date(from).setHours(0, 0, 0, 0);
  const t2 = new Date(to).setHours(0, 0, 0, 0);
  const diffMs = t2 - t1;
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export default function TrialBanner() {
  const [trialInfo, setTrialInfo] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const { data } = await axiosInstance.get('/auth/me');
        if (!mounted) return;

        const t = data?.trial;
        if (!t || !t.ends_at) {
          setTrialInfo(null);
          setLoading(false);
          return;
        }

        const now = new Date();
        const end = new Date(t.ends_at);
        if (now > end) {
          // essai terminé → pas de bandeau
          setTrialInfo(null);
          setLoading(false);
          return;
        }

        const daysLeft = diffInDays(now, end);
        setTrialInfo({
          ends_at: t.ends_at,
          daysLeft,
        });
        setLoading(false);
      } catch (e) {
        console.warn('[TrialBanner] /auth/me error', e);
        setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading || hidden || !trialInfo) return null;

  const { daysLeft } = trialInfo;

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 text-amber-900 text-sm">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div>
          <strong>Période d’essai FlowDevis</strong>{' '}
          {daysLeft > 1 ? (
            <>– il vous reste <strong>{daysLeft} jours</strong> pour tester l’application.</>
          ) : (
            <>– <strong>dernier jour</strong> de votre essai gratuit.</>
          )}{' '}
          <button
            type="button"
            onClick={() => (window.location.href = '/parametres/abonnement')}
            className="ml-2 inline-flex items-center px-2.5 py-1 rounded-full bg-amber-600 text-white text-xs font-semibold hover:bg-amber-700"
          >
            Voir les offres d’abonnement
          </button>
        </div>

        <button
          type="button"
          onClick={() => setHidden(true)}
          className="shrink-0 inline-flex items-center justify-center h-6 w-6 rounded-full border border-amber-300 text-amber-700 hover:bg-amber-100 text-xs"
          aria-label="Fermer le message d’essai"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
